<div [ngClass]="containerClass">
  <div id="sideMenuBar" class="side-menu-bar" (mouseleave)="resetMenu()">
    <!-- Submenu items -->
    <ul class="buddy-nav buddy-nav--compact js-buddy-nav sidemenu-bar" [ngClass]="subMenuClass" id="subMenuBarInner">
      @if (showMainMenuLink()) {
        <li class="buddy-nav__item buddy-nav__back mb-2">
          <div class="buddy-nav__link js-buddy-nav__link pointer" (click)="openModules()">
            <span class="buddy-nav__label ng-binding"><span [innerHTML]="'SB_Main_Menu' | translate"></span></span>
            <sb-icon-svg-img
              [imgUrl]="'menu/back.svg'"
              class="buddy-nav__icon"
              [ngbTooltip]="'SB_Main_Menu' | translate"
              placement="{{ getTooltipPlacement() }}"
              tooltipClass="buddy-nav__tooltip"
              [disableTooltip]="disableTooltips"
              container="body">
            </sb-icon-svg-img>
          </div>
        </li>
      }
      <ng-container
        *ngFor="let item of visibleSubMenuItems() | orderBy: 'sortOrder' as visibleSubMenuItems; let i = index">
        <ng-container
          [ngTemplateOutlet]="menuItem"
          [ngTemplateOutletContext]="{ item: item, i: i, menuItems: visibleSubMenuItems }"></ng-container>
        @if (showChildItems(item)) {
          @for (child of getChildItems(item); track child.route) {
            <ng-container
              [ngTemplateOutlet]="menuItem"
              [ngTemplateOutletContext]="{ item: child, i: i, menuItems: visibleSubMenuItems, isChild: true }"></ng-container>
          }
        }
      </ng-container>
    </ul>
    <!-- Main menu/module items -->
    <ul
      class="buddy-nav buddy-nav--compact js-buddy-nav sub-menu-bar-inner-modules"
      id="subMenuBarInnerModules"
      [ngClass]="modulesClass"
      tabindex="-1">
      @for (item of mainMenuItems | orderBy: 'sortOrder'; track item; let i = $index) {
        <ng-container
          [ngTemplateOutlet]="menuItem"
        [ngTemplateOutletContext]="{ item: item, i: i, menuItems: mainMenuItems }"></ng-container>
      }
    </ul>
    @if (showCurrentPageMenuItems) {
      <ul
        class="buddy-nav buddy-nav--compact js-buddy-nav sub-menu-bar-inner-modules"
        id="subMenuBarInnerPageMenuItems"
        [ngClass]="currentPageMenuClass"
        tabindex="-1">
        @if (isStaff) {
          <li class="buddy-nav__item buddy-nav__back mb-2">
            <div class="buddy-nav__link js-buddy-nav__link pointer" (click)="hideCurrentPageMenuItems()">
              <span class="buddy-nav__label ng-binding"
                ><span [innerHTML]="expandedMenuItem?.label | translate"></span
              ></span>
              <span
                class="buddy-nav__icon fas fa-level-up-alt"
                [ngbTooltip]="'SB_Back' | translate"
                placement="{{ getTooltipPlacement() }}"
                tooltipClass="buddy-nav__tooltip"
                [disableTooltip]="disableTooltips"
              container="body"></span>
            </div>
          </li>
        }
        @for (item of currentPageMenuItems | orderBy: 'sortOrder'; track item; let i = $index) {
          <ng-container
            [ngTemplateOutlet]="menuItem"
          [ngTemplateOutletContext]="{ item: item, i: i, menuItems: currentPageMenuItems }"></ng-container>
        }
      </ul>
    }
  <div class="menu-logos">
    <img [src]="cdnBase + 'logos/faria_education_logo.png'" style="height: 60px; width: auto; margin-left: 10px;">
    <img [src]="cdnBase + 'logos/sb_logo.png'" style="height: 35px; width: auto; margin-left: -5px;">
  </div>


  </div>
</div>

<ng-template #menuItem let-item="item" let-i="i" let-menuItems="menuItems" let-isChild="isChild">
  @if (!isChild && showSeparator(menuItems, i)) {
    <div role="separator" class="divider visible-xs"></div>
  } @else if (!isChild && item.showDivider) {
    <div role="separator" class="divider simple"></div>
  }
  @if (item.route) {
    <li
      class="buddy-nav__item"
      [hidden]="item.isHidden"
      routerLinkActive="buddy-nav__item--active"
      #rla="routerLinkActive"
      [ngClass]="{ 'visible-xs': item.isXsOnly || item.isRightMenu, 'buddy-nav__item--child': isChild }">
      @if (hasSubMenuItems(item)) {
        <a [routerLink]="item.route">
          <div class="buddy-nav__link js-buddy-nav__link" (click)="expandSubMenuItem($event, item)">
            <ng-container
              [ngTemplateOutlet]="menuItemContent"
            [ngTemplateOutletContext]="{ item: item, rla: rla }"></ng-container>
          </div>
        </a>
      }
      @if (!hasSubMenuItems(item)) {
        <a class="buddy-nav__link js-buddy-nav__link" [routerLink]="item.route">
          <ng-container
            [ngTemplateOutlet]="menuItemContentWithBadge"
          [ngTemplateOutletContext]="{ item: item, rla: rla }"></ng-container>
        </a>
      }
    </li>
  }
  @if (item.externalUrl) {
    <li class="buddy-nav__item" [ngClass]="{ 'visible-xs': item.isXsOnly || item.isRightMenu }">
      <a class="buddy-nav__link js-buddy-nav__link" [href]="item.externalUrl">
        <ng-container [ngTemplateOutlet]="menuItemContent" [ngTemplateOutletContext]="{ item: item }"></ng-container>
      </a>
    </li>
  }
</ng-template>

<ng-template #menuItemContentWithBadge let-item="item" let-rla="rla">
  @if (item.count) {
    <div class="badge-container">
      <sb-badge [message]="item.count" [isRounded]="true" badgeClass="danger"></sb-badge>
    </div>
  }
  <ng-container
    [ngTemplateOutlet]="menuItemContent"
  [ngTemplateOutletContext]="{ item: item, rla: rla }"></ng-container>
</ng-template>

<ng-template #menuItemContent let-item="item" let-rla="rla">
  <span class="buddy-nav__label">
    <span [innerHTML]="item.label | translate"></span>
    {{ item.params }}
  </span>
  @if (isSvgIcon(item)) {
    <sb-icon-svg-img
      [imgUrl]="item.iconImageUrl"
      class="buddy-nav__icon"
      [ngbTooltip]="item.label | translate"
      placement="{{ getTooltipPlacement() }}"
      tooltipClass="buddy-nav__tooltip"
      [disableTooltip]="disableTooltips"
      container="body">
    </sb-icon-svg-img>
  } @else {
    <span
      class="buddy-nav__icon {{ getIcon(item, rla?.isActive, true) }}"
      [innerHTML]="item.iconHtml"
      [ngbTooltip]="item.label | translate"
      placement="{{ getTooltipPlacement() }}"
      tooltipClass="buddy-nav__tooltip"
      [disableTooltip]="disableTooltips"
      container="body"></span>
  }
</ng-template>
